// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CurrencyDollarIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CurrencyDollar/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.434 7.418c.154-.103.346-.196.566-.267v1.698a2.305 2.305 0 0 1-.566-.267C8.069 8.34 8 8.114 8 8c0-.114.07-.34.434-.582ZM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.304 2.304 0 0 1-.567.267Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a1 1 0 1 0-2 0v.092a4.535 4.535 0 0 0-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.055.545 1.676.662v1.941c-.39-.127-.68-.317-.843-.504a1 1 0 1 0-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 1 0 2 0v-.092a4.536 4.536 0 0 0 1.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.534 4.534 0 0 0 11 9.092V7.151c.391.127.681.317.844.504a1 1 0 0 0 1.51-1.31c-.562-.649-1.413-1.076-2.354-1.253V5Z",
  clipRule: "evenodd"
}));
export default CurrencyDollarIcon;